/**
 * Sitemap API Service
 * 
 * V228: Enhanced with content breakdown support (web, image, video, news).
 * 
 * Handles sitemap submission status from GSC and Bing.
 * Migrated from seo-engine-webtools-customer-module
 */

import customerApi from './customerApi';
import { SitemapResponse } from '@/types/customer';


export interface GetSitemapParams {
  tool?: 'GSC' | 'BING';
  status?: 'SUCCESS' | 'PENDING' | 'ERROR';
}

/**
 * Get sitemap status data for a site
 * Returns sitemap list with content breakdown per sitemap
 */
export async function getSitemapStatus(
  siteId: number,
  params?: GetSitemapParams
): Promise<SitemapResponse> {
  const queryParams = new URLSearchParams();
  if (params?.tool) queryParams.set('tool', params.tool);
  if (params?.status) queryParams.set('status', params.status);

  const response = await customerApi.get<SitemapResponse>(
    `/webtools/sites/${siteId}/sitemaps?${queryParams}`
  );
  return response.data;
}

export default {
  getSitemapStatus,
};
